import { ProviderDashboardResourceType } from '@tempus/trials-types';
import { LookerEmbedCookielessTokenData } from '@looker/embed-sdk';

import axios from '../axios';
import { TRIALS_NEST_API_ROOT, getProviderReportingRequestConfig } from '../constants';
import type {
  GetProviderDashboardsResponse,
  GetProviderDashboardSignedUriResponse,
  ProviderDashboard,
} from '../types/providerReporting';

export const providerDashboardsApi = {
  getProviderDashboards: async (resourceType: ProviderDashboardResourceType): Promise<ProviderDashboard[]> => {
    return axios
      .get<GetProviderDashboardsResponse>(
        `${TRIALS_NEST_API_ROOT}/provider-dashboards/resource-type/${resourceType}`,
        getProviderReportingRequestConfig(),
      )
      .then(({ data }) => data.providerDashboards);
  },
  getSignedUri: async (
    id: string,
    resourceType: ProviderDashboardResourceType,
    resourceId: string,
  ): Promise<GetProviderDashboardSignedUriResponse> => {
    return axios
      .get<GetProviderDashboardSignedUriResponse>(
        `${TRIALS_NEST_API_ROOT}/provider-dashboards/${id}/resource-type/${resourceType}/resource-id/${resourceId}`,
        getProviderReportingRequestConfig(),
      )
      .then(({ data }) => data);
  },
  acquireCookielessSession: async (id: string, resourceType: ProviderDashboardResourceType, resourceId: string) => {
    return axios
      .post(
        `${TRIALS_NEST_API_ROOT}/provider-dashboards/${id}/resource-type/${resourceType}/resource-id/${resourceId}/embed/acquire-session`,
        {},
        getProviderReportingRequestConfig(),
      )
      .then(({ data }) => data);
  },
  generateCookielessTokens: async (
    id: string,
    resourceType: ProviderDashboardResourceType,
    resourceId: string,
    tokens: LookerEmbedCookielessTokenData,
  ) => {
    return axios
      .post(
        `${TRIALS_NEST_API_ROOT}/provider-dashboards/${id}/resource-type/${resourceType}/resource-id/${resourceId}/embed/generate-tokens`,
        tokens,
        getProviderReportingRequestConfig(),
      )
      .then(({ data }) => data);
  },
};
